import EventFeedFilters from './EventFeedFilters';

export default EventFeedFilters;
